import React from 'react';

import {
  Button,
} from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import { useContext } from './Context';

export default function ChatList() {
  const { dispatch, actions, state } = useContext();

  const onChatClick = (chat) => {
    actions.loadChat(dispatch, state.token, chat.session_id);
  };

  const onChatDelete = (chat) => {
    confirmAlert({
      title: 'Delete Chat',
      text: 'Are you sure that you want to delete this chat?',
      confirmButtonText: 'Delete',
    }, () => {
      actions.deleteChat(dispatch, state.token, chat.session_id);
      if (state.currentChatId === chat.session_id) {
        actions.setNewChatAfterDelete(dispatch);
      }
    });
  };

  return (
    <>
      {state.chats.map((chat) => (
        <div className="chat d-flex justify-content-between">
          <div className="chat-title" onClick={() => onChatClick(chat)}>{chat.title}</div>
          <Button
            variant=""
            className="delete-chat p-0"
            onClick={() => onChatDelete(chat)}
          >
            <IconWithText
              iconClassName="close-icon small-icon"
            />
          </Button>
        </div>
      ))}
    </>
  );
}
